import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import CheckoutVatReverseChargeCheckbox from '../shared/CheckoutVatReverseChargeCheckbox';
import { vatMessages } from 'dibs-vat-utils/exports/vatMessages';
import getBuyerSupportLink from 'dibs-support-link/exports/getBuyerSupportLink';

import styles from './styles/CheckoutVatReverseCharge.scss';

import { CheckoutVatReverseCharge_transaction$key } from './__generated__/CheckoutVatReverseCharge_transaction.graphql';
import { CheckoutVatReverseCharge_viewer$key } from './__generated__/CheckoutVatReverseCharge_viewer.graphql';

type Props = {
    transaction: CheckoutVatReverseCharge_transaction$key;
    viewer: CheckoutVatReverseCharge_viewer$key;
    isComputing: boolean;
};

const CheckoutVatReverseCharge: FC<Props> = ({
    viewer: viewerRef,
    transaction: transactionRef,
    isComputing,
}) => {
    const viewer = useFragment(
        graphql`
            fragment CheckoutVatReverseCharge_viewer on Viewer {
                ...CheckoutVatReverseChargeCheckbox_viewer
            }
        `,
        viewerRef
    );
    const transaction = useFragment(
        graphql`
            fragment CheckoutVatReverseCharge_transaction on Transaction {
                hasBuyerReverseChargeAction: hasAction(actionCode: "BUYER_REVERSE_CHARGE_ELIGIBLE")
                canBeVatReverseCharge
                priceBookName
                ...CheckoutVatReverseChargeCheckbox_transaction
            }
        `,
        transactionRef
    );

    const { hasBuyerReverseChargeAction, canBeVatReverseCharge, priceBookName } = transaction || {};

    let content = null;
    if (hasBuyerReverseChargeAction) {
        if (canBeVatReverseCharge) {
            content = (
                <CheckoutVatReverseChargeCheckbox
                    transaction={transaction}
                    viewer={viewer}
                    isComputing={isComputing}
                />
            );
        } else {
            content = (
                <div className={styles.container}>
                    *
                    <span className={styles.messageContainer}>
                        {vatMessages.ifThisPurchaseIsEligible({ priceBookName })}{' '}
                        <Link
                            href={getBuyerSupportLink('/en-us/articles/14491733706907/')}
                            target="_blank"
                        >
                            <FormattedMessage
                                id="checkout.CheckoutReverseCharge.learnMore"
                                defaultMessage="Learn more"
                            />
                        </Link>
                    </span>
                </div>
            );
        }
    }

    return content;
};

export default CheckoutVatReverseCharge;
